export const siteConfig = {
  productName: 'reciboofertas',
  launchCity: 'CDMX',
  country: 'México',
  contactEmail: 'hello@reciboofertas.com',
  links: {
    privacy: '',
    terms: '',
    instagram: '',
    tiktok: '',
  },
} as const;
